import { defineComponent as C, ref as p, watch as f, onMounted as L, onUnmounted as _, openBlock as r, createElementBlock as d, normalizeClass as l, unref as t, createElementVNode as a, toDisplayString as A, createCommentVNode as h, createTextVNode as B, createVNode as x, renderSlot as S } from "vue";
import { IconActionQuestionMarkCircle as D, IconActionDelete as E } from "@cypress-design/vue-icon";
const g = "data-modal-scroll-top", y = "cy-modal-overflow-hidden";
function M() {
  document.body.setAttribute(g, `${window.scrollY}`), document.documentElement.clientWidth > window.innerWidth && document.documentElement.classList.add("cy-modal-overflow-scroll-x"), document.documentElement.clientHeight > window.innerHeight && document.documentElement.classList.add("cy-modal-overflow-scroll-y"), document.body.classList.add(y);
}
function w() {
  const i = parseInt(document.body.getAttribute(g) || "0");
  document.body.classList.remove(y), document.documentElement.classList.remove("cy-modal-overflow-scroll-x"), document.documentElement.classList.remove("cy-modal-overflow-scroll-y"), window.scrollTo({ top: i });
}
const T = "pointer-events-auto fixed flex flex-col rounded outline outline-4 outline-gray-500/[.40] bg-white backdrop:bg-gray-900/[.80] backdrop:backdrop-blur-sm", N = "max-h-[80vh] min-w-[200px] sm:min-w-[390px] max-w-[calc(100vw-32px)] sm:max-w-[70vw] shrink-0", O = "h-[calc(100vh-32px)] sm:w-[calc(100vw-32px)]", Y = "flex shrink-0 items-center justify-between rounded-t-md border-b border-gray-100 p-[16px] px-16px sm:px-[24px]", $ = "text-[18px] font-medium leading-[28px] text-gray-900", H = "mx-[8px] h-[1px] w-[32px] bg-gray-100", I = "flex items-center text-[16px] font-normal leading-[24px] text-indigo-500", V = "group rounded-full border-transparent p-[4px] outline-none", R = "overflow-y-auto p-[16px] sm:px-[24px]", W = ["href"], X = /* @__PURE__ */ a("div", { class: "grow" }, null, -1), z = /* @__PURE__ */ C({
  __name: "Modal",
  props: {
    title: {},
    show: { type: Boolean },
    helpLink: {},
    fullscreen: { type: Boolean }
  },
  emits: ["close", "update:show"],
  setup(i, { emit: v }) {
    const n = p(!1), m = v, k = i, c = p();
    f(
      () => k.show,
      (e) => {
        n.value = e;
      },
      { immediate: !0 }
    ), L(() => {
      if (!document.querySelector("#modal-target")) {
        const e = document.createElement("div");
        e.id = "modal-target", document.body.appendChild(e);
      }
    }), f(n, (e) => {
      var o, s;
      e ? (M(), (o = c.value) == null || o.showModal()) : ((s = c.value) == null || s.close(), w()), m("update:show", e), e || m("close");
    }), _(() => {
      w();
    });
    function b(e) {
      var u;
      var o = (u = c.value) == null ? void 0 : u.getBoundingClientRect();
      if (o) {
        var s = o.top <= e.clientY && e.clientY <= o.top + o.height && o.left <= e.clientX && e.clientX <= o.left + o.width;
        s || (n.value = !1);
      }
    }
    return (e, o) => (r(), d("dialog", {
      ref_key: "$dialog",
      ref: c,
      class: l([
        n.value ? t(T) : null,
        e.fullscreen ? t(O) : t(N)
      ]),
      onClick: b
    }, [
      a("div", {
        class: l(t(Y))
      }, [
        a("div", {
          id: "cy_modal_label",
          class: l(t($))
        }, A(e.title), 3),
        e.helpLink ? (r(), d("div", {
          key: 0,
          class: l(t(H))
        }, null, 2)) : h("", !0),
        e.helpLink ? (r(), d("a", {
          key: 1,
          href: e.helpLink,
          class: l(t(I)),
          target: "_blank"
        }, [
          B(" Need help "),
          x(t(D), {
            class: "ml-[4px]",
            "stroke-color": "indigo-500",
            "fill-color": "indigo-100"
          })
        ], 10, W)) : h("", !0),
        X,
        a("button", {
          "aria-label": "Close",
          class: l(t(V)),
          onClick: o[0] || (o[0] = (s) => n.value = !1)
        }, [
          x(t(E), {
            class: "children:transition-all",
            "stroke-color": "gray-400",
            "hover-stroke-color": "gray-700",
            "interactive-colors-on-group": ""
          })
        ], 2)
      ], 2),
      a("div", {
        class: l(t(R))
      }, [
        S(e.$slots, "default")
      ], 2)
    ], 2));
  }
});
export {
  z as default
};
//# sourceMappingURL=index.es.mjs.map

/* <wind-keep class="ml-[4px] grow icon-dark-indigo-500 icon-light-indigo-100 icon-dark-gray-400 icon-hover:icon-dark-gray-700 group-hover:icon-dark-gray-700 pointer-events-auto fixed flex flex-col rounded outline outline-4 outline-gray-500/[.40] bg-white backdrop:bg-gray-900/[.80] backdrop:backdrop-blur-sm max-h-[80vh] min-w-[200px] sm:min-w-[390px] max-w-[calc(100vw-32px)] sm:max-w-[70vw] shrink-0 h-[calc(100vh-32px)] sm:w-[calc(100vw-32px)] items-center justify-between rounded-t-md border-b border-gray-100 p-[16px] sm:px-[24px] text-[18px] font-medium leading-[28px] text-gray-900 mx-[8px] h-[1px] w-[32px] bg-gray-100 text-[16px] font-normal leading-[24px] text-indigo-500 rounded-full border-transparent p-[4px] outline-none overflow-y-auto cy-modal-overflow-hidden cy-modal-overflow-scroll-x cy-modal-overflow-scroll-y"> */
